import { getReCAPTCHAResponse } from '@theme/utilities';
import ReactDOM from 'react-dom/client';
import App from './components/App';

const el = document.querySelector('#blog-feedback');

if (el) {
	const root = ReactDOM.createRoot(el);

	getReCAPTCHAResponse('blogFeedbackVisibility')
		.then((response) => {
			if (response.success && response.score >= 0.5) {
				root.render(
					<App
						contentHash={el.getAttribute('data-content-hash')}
						dataUrl={el.getAttribute('data-rest-url')}
						postId={parseInt(el.getAttribute('data-post-id'))}
						postUrl={el.getAttribute('data-post-url')}
						language={el.getAttribute('data-language')}
					/>,
				);
			}
		})
		.catch((error) => {
			console.error(error);
		});
}
